import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as BusinessActions from './business.actions';
import { BusinessEntity, BusinessState } from './business.models';

export const BUSINESS_FEATURE_KEY = 'business';

export interface EntityModel {
  userId?: number;
  businessId?: number;
  name?: string;
  mentionName?: string;
  avatarPath?: string;
}

export interface BusinessPartialState {
  readonly [BUSINESS_FEATURE_KEY]: BusinessState;
}

export const businessAdapter: EntityAdapter<BusinessEntity> = createEntityAdapter<BusinessEntity>();

export const initialBusinessState: BusinessState = businessAdapter.getInitialState({});

const reducer = createReducer(
  initialBusinessState,

  on(BusinessActions.getBusinessByIdSuccess, (state, { business }) => {
    return {
      ...state,
      selectedBusiness: business,
    };
  }),

  on(BusinessActions.updateVerifyBusiness, (state, { verifyData }) => ({
    ...state,
    verifyData: {
      ...(state.verifyData ?? {
        has_access: false,
        has_business: false,
        business_id: 0,
        is_deleted: false,
        is_active: false,
      }),
      ...verifyData,
    },
  })),
  on(BusinessActions.resetSelectedBusiness, (state) => ({
    ...state,
    selectedBusiness: undefined,
  })),
  on(BusinessActions.updateSelectedBusiness, (state, { business }) => ({
    ...state,
    selectedBusiness: {
      ...state.selectedBusiness,
      ...(business as any),
    },
  })),
);

export function businessReducer(state: BusinessState | undefined, action: Action): BusinessState {
  return reducer(state, action);
}
